import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionMetadata", "getHeaderTitle", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import Action from 'automation-ui-action-features/records/Action';
import DelayActionMetadata from 'automation-ui-action-features/actions/delay/records/DelayActionMetadata';
import DelayActionSummary from 'automation-ui-action-features/actions/delay/DelayActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function DelayActionCard(_ref) {
  let {
      actionMetadata,
      getHeaderTitle,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(DelayActionSummary, {
      actionMetadata: actionMetadata
    })
  }));
}
DelayActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  action: PropTypes.instanceOf(Action),
  actionMetadata: PropTypes.instanceOf(DelayActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default DelayActionCard;